import clsx from "clsx";
import { HTMLAttributes, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export interface NavigationSectionProps extends HTMLAttributes<HTMLDivElement> {
  main?: boolean;
}

const NavigationSection = forwardRef<HTMLDivElement, NavigationSectionProps>(
  (props, ref) => {
    const { main = false, className, ...rest } = props;
    return (
      <div
        {...rest}
        ref={ref}
        className={twMerge(
          clsx("flex", {
            "flex-auto": main,
            "items-center": !main,
          }),
          className
        )}
      />
    );
  }
);

export default NavigationSection;
